const statusPorSituacao = [
    {
        regra: 'DESP-GERAIS-FINAN-PAG-02',
        situacoes: [
            {
                id: 0,
                status: [-1, 0, 1, 2, 3, 4, 5, 8]
            },
            {
                id: 1,
                status: [-1, 0, 1, 3, 4]
            },
            {
                id: 2,
                status: [-1, 8, 2]
            },
            {
                id: 3,
                status: [-1, 5]
            }
        ]
    }
]

export default statusPorSituacao
